import { render, staticRenderFns } from "./return_list.vue?vue&type=template&id=1d54374a&scoped=true"
import script from "./return_list.vue?vue&type=script&lang=js"
export * from "./return_list.vue?vue&type=script&lang=js"
import style0 from "./return_list.vue?vue&type=style&index=0&id=1d54374a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54374a",
  null
  
)

export default component.exports